import { ROSARY_PRAYERS } from "./rosary";
import { CHAPLET_LOCALES } from "./chapletLocales";

export const CHAPLET_LANGUAGES = [{ id: "en", label: "English" }, { id: "es", label: "Español" }, { id: "fr", label: "Français" }];
export const chapletUI = (lang = "en") => CHAPLET_LOCALES[lang] || CHAPLET_LOCALES.en;
export const CHAPLET_SOURCE = "https://www.saint-faustina.org/chaplet-of-the-divine-mercy/";
export const chapletSource = (lang) => lang === "fr" ? "https://www.soeurfaustine.fr/chapelet-a-la-misericorde-divine/" : CHAPLET_SOURCE;

export function buildChapletSteps(lang = "en") {
  const t = chapletUI(lang);
  const opening = (key, anchor) => ({ kind: "open", key, anchor, label: ROSARY_PRAYERS[key].titles[lang], text: ROSARY_PRAYERS[key][lang] });
  // One prayer on each small introductory bead. The optional prayers occupy the
  // lower large bead; no extra Hail Marys or Glory Be are added to the Chaplet.
  const steps = [opening("sign", "crucifix"),
    { kind: "open", key: "optional", anchor: "intro-our-father", label: t.optional, text: t.prayers.optional },
    opening("our_father", "intro-hail-1"), opening("hail_mary", "intro-hail-2"), opening("creed", "intro-hail-3")];
  for (let index = 0; index < 5; index += 1) {
    steps.push({ kind: "our_father_bead", key: "eternal_father", index, decade: index + 1, anchor: `decade-our-father-${index}`, label: `${t.decade} ${index + 1} · ${t.large}`, text: t.prayers.eternal_father });
    for (let bead = 1; bead <= 10; bead += 1) steps.push({ kind: "bead", key: "aspiration", index, decade: index + 1, bead, anchor: `decade-hail-${index}-${bead}`, label: `${t.decade} ${index + 1} · ${t.bead} ${bead} ${t.of} 10`, text: t.prayers.aspiration });
  }
  steps.push({ kind: "close", key: "holy_god", anchor: "medal", label: t.conclude, text: Array(3).fill(t.prayers.holy_god).join("\n\n") });
  steps.push({ kind: "close", key: "closing", anchor: "medal", label: t.closing, text: t.prayers.closing });
  return steps;
}

export function chapletCard(lang = "en") {
  const t = chapletUI(lang);
  return {
    lang, compact: true, eyebrow: t.trust, title: t.cardTitle, subtitle: t.eyebrow,
    image: { src: "/images/christos/divine-mercy.webp", alt: t.cardTitle, credit: "Theotokos · Mater Dei" },
    blocks: [{ label: t.begin, text: t.beginText }, { label: t.large, text: t.prayers.eternal_father, italic: true }, { label: t.small, text: t.prayers.aspiration, italic: true }, { label: t.conclude, text: t.prayers.holy_god, italic: true }],
    source: { label: t.source, url: chapletSource(lang) },
    back: { eyebrow: "Iesu, in Te confido", name: t.cardTitle, blessing: t.trust },
    footer: "Theotokos · Mater Dei — Christos · Rex Gloriae",
  };
}

export const DIVINE_MERCY_CHAPLET = { ...chapletUI("en"), card: chapletCard("en") };